const HTTP_PROTOCOLS = new Set(["http:", "https:"]);
const SCHEME_PATTERN = /^[A-Za-z][A-Za-z\d+.-]*:/;

function runtimeBaseUrl() {
  return globalThis.document?.baseURI
    ?? globalThis.location?.href
    ?? "http://localhost/";
}

export function safeHttpUrl(
  value,
  {
    allowedOrigins = [],
    allowAnyHttps = false,
    allowSameOrigin = true,
    baseUrl = runtimeBaseUrl(),
  } = {},
) {
  if (typeof value !== "string" || value.trim().length === 0) return null;

  const candidate = value.trim();
  if (/\p{Cc}/u.test(candidate) || candidate.startsWith("//") || candidate.includes("\\")) {
    return null;
  }

  let base;
  let url;
  try {
    base = new URL(baseUrl);
    url = new URL(candidate, base);
  } catch {
    return null;
  }

  if (!HTTP_PROTOCOLS.has(url.protocol)) return null;
  if (url.username || url.password) return null;

  const isRelative = !SCHEME_PATTERN.test(candidate);
  if (isRelative && allowSameOrigin && url.origin === base.origin) {
    return `${url.pathname}${url.search}${url.hash}`;
  }

  if (allowSameOrigin && url.origin === base.origin) return url.href;
  if (url.protocol !== "https:") return null;

  const trustedOrigins = new Set(allowedOrigins);
  if (!allowAnyHttps && !trustedOrigins.has(url.origin)) return null;

  return url.href;
}

export const YOUTUBE_POSTER_ORIGINS = Object.freeze([
  "https://i.ytimg.com",
  "https://img.youtube.com",
]);

export const SUCHARD_VIDEO_ORIGINS = Object.freeze([
  "https://www.suchard.es",
]);
